
class Validate {
  isEmailValid(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  decodeEntities(value) {
    if (typeof document === "undefined") return value;
    const el = document.createElement("textarea");
    el.innerHTML = value;
    return el.value;
  }

  noXSS(inputValue) {
    if (!inputValue) return true;

    const sanitizedInput = inputValue.trim();

    const encodedTagPattern = /&gt;\s*/i; // e.g. "/&gt;<a..."
    const rawTagPattern = /<\s*\/?\s*\w+/i; // raw "<tag"
    const suspiciousEntityPattern = /&lt;\/?\w+|&#x?[\da-f]+;/i; // encoded tags / hex entities
    const dangerousProtocolPattern = /(?:javascript:|data:|vbscript:)/i;
    const commandInjectionPattern = /\|\s*\?|\$_.+?length|\bwrite-host\b|\bget-childitem\b|\bselect-string\b|\bpowershell\b/i;

    if (
      rawTagPattern.test(sanitizedInput) ||
      dangerousProtocolPattern.test(sanitizedInput) ||
      encodedTagPattern.test(sanitizedInput) ||
      suspiciousEntityPattern.test(sanitizedInput) ||
      commandInjectionPattern.test(sanitizedInput)
    ) {
      return false;
    }

    const decodedInput = this.decodeEntities(sanitizedInput).toLowerCase();

    const dangerousPattern =
      /<\/\s*script\s*>|<\s*script\b[^>]*>|<\s*\w+\b[^>]*\son\w+\s*=|javascript:|data:text\/html|<\s*(iframe|object|embed|svg)\b[^>]*>/gi;

    return !(
      dangerousPattern.test(decodedInput) ||
      commandInjectionPattern.test(decodedInput)
    );
  }
}
export default new Validate();
